import React from "react";

export const PolicyPage = () => {
  return (
    <div className="heroNotGame">
      <p className="title">Polityka Prywatności</p>
    </div>
  );
};
